{
  "dashboard": {
    "title": "Pannello di controllo"
  },
  "devices": {
    "title": "Apparati"
  },
  "device": {
    "title": "Apparato"
  },
  "dtwins": {
    "title": "Device twins"
  },
  "dtwin": {
    "title": "Apparato LPP4"
  },
  "users": {
    "title": "Utenti"
  },
  "user": {
    "title": "Utenti"
  },
  "profiles": {
    "title": "Profili"
  },
  "applications": {
    "title": "Applicazioni"
  },
  "campaigns": {
    "title": "Campagne"
  },
  "logs": {
    "title": "Registro"
  },
  "sectors": {
    "details": {
      "title": "Dettagli della rete {name}"
    },
    "title": "Reti"
  },
  "parameters": {
    "title": "Configurazione"
  },
  "userGroups": {
    "title": "Gruppi"
  },
  "pkiConnector": {
    "title": "Connettore PKI"
  },
  "truststore": {
    "title": "Truststore"
  },
  "firmware": {
    "title": "Firmware"
  },
  "filters": "Filtri",
  "certificateAlertReporting": {
    "title": "Report"
  },
  "certificate-management": {
    "title": "Certificati"
  },
  "applicationMgts": {
    "title": "Applicazioni"
  },
  "license": {
    "title": "Licenza"
  },
  "userAccount": {
    "title": "Account utente"
  },
  "about": {
    "title": "Informazioni",
    "downloadTitle": "Scaricare i log"
  },
  "deviceConfiguration": {
    "title": "Configurazione degli apparati"
  },
  "platformMgt": {
    "title": "Informazioni",
    "downloadTitle": "Scaricare i log"
  },
  "componentsVersion": {
    "title": "Informazioni"
  },
  "certificates": {
    "title": "Certificati"
  },
  "fleets": {
    "title": "Flotte"
  },
  "businessUnits": {
    "title": "Modifica {name}"
  },
  "organizations": {
    "title": "Modifica {name}"
  },
  "interfaces": {
    "title": "Interfacce"
  }
}
